import React from 'react'
import { store } from '../../Redux/store';
import uuidv4 from "uuid/v4";
import _get from "lodash-es/get";
import { CHAT_TYPE_SINGLE, CHAT_TYPE_GROUP, CHAT_TYPE_BROADCAST, GROUP_CHAT_PROFILE_UPDATED_NOTIFY, MSG_SENT_ACKNOWLEDGE_STATUS_ID, MSG_DELIVERED_STATUS_ID, MSG_SEEN_STATUS_ID, MSG_PROCESSING_STATUS_ID, BRAND_NAME, REPORT_FROM_CONTACT_INFO } from './Constant'
import {
    formatGroupIdToJid, getContactNameFromRoster,
    getDataFromRoster, getSenderIdFromMsgObj, getUserDetails, isLocalUser
} from './User.js';
import { blockOfflineAction,
            capitalizeFirstLetter,
            getArchiveSetting,
            getLocalWebsettings,
            // fileToBlob,
            getMessageType, getUserIdFromJid, setLocalWebsettings } from '../Utility';
import moment from 'moment';
import { DateTime } from 'luxon';
import { encryptAndStoreInLocalStorage, getFromLocalStorageAndDecrypt } from './webChatEncryptDecrypt';
import { msgStatusOrder } from './RecentChat';
import {  IconUploadingHoc } from '../../assets/images';
import SDK from '../../SDK';
import CustomIcon from '../../assets/images/CustomIcon';
import { addReplyMessageData } from '../../Redux/feature/replyMessageDataSlice';
import { removePendindMedia } from '../../Redux/feature/pendingMediaSlice';
import {  updateUploadStatus } from '../../Redux/feature/chatConversationHistorySlice';
import { getExtension } from '../../Components/WebChat/Common/FileUploadValidation';
import { addMessageInfoData } from '../../Redux/feature/messageInfoDataSlice';
import { addRecentChatStatus } from '../../Redux/feature/recentChatStatusSlice';
import { webLocalStorageSetting } from '../../Redux/feature/webLocalStorageSettingDataSlice';
import config from '../../config';
export const isSingleChat = (chatType) => chatType === CHAT_TYPE_SINGLE;
export const isGroupChat = (chatType) => chatType === CHAT_TYPE_GROUP;
export const isBroadcastChat = (chatType) => chatType === CHAT_TYPE_BROADCAST;
export const isSingleOrGroupChat = (chatType) => chatType === CHAT_TYPE_SINGLE || chatType === CHAT_TYPE_GROUP;
const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const {reportMembers} = config
export const deliveryStatus = {
    [MSG_SENT_ACKNOWLEDGE_STATUS_ID]: "offline",
    [MSG_DELIVERED_STATUS_ID]: "notsent",
    [MSG_SEEN_STATUS_ID]: "sent",
    [MSG_PROCESSING_STATUS_ID]: "processing"
};

export const isSameSession = () => {
    return getFromLocalStorageAndDecrypt("sessionId") === getFromSessionStorageAndDecrypt("sessionId")
}


export const getArchivedChats = () => {
    const { recentChatData: { data = [] } = {} } = store.getState();
    const chatIds = [];
    data.forEach(recent => {
        if (recent.archiveStatus === 1) chatIds.push(recent.fromUserId);
    });
    return chatIds;
};

export const getMutedChats = () => {
    const { recentChatData: { data = [] } = {} } = store.getState();
    const chatIds = [];
    data.forEach(recent => {
        if (recent.muteStatus === 1) chatIds.push(recent.fromUserId);
    });
    return chatIds;
};

export const notificationMessageType = ["1", "2", "3", "4", "5"];
/**
 * Check the give USER or GROUP ID is in the active conversation screen
 * @param {string} userOrGroupId 
 * @param {string} chatType 
 */
export const isActiveConversationUserOrGroup = (userOrGroupId, chatType = CHAT_TYPE_SINGLE) => {
    if (!userOrGroupId) return false;
    const conversationUserOrGroupId = isSingleChat(chatType) ? getActiveConversationChatId() : getActiveConversationGroupId();
    userOrGroupId = getUserIdFromJid(userOrGroupId);
    return conversationUserOrGroupId === userOrGroupId;
}

export const isTextMessage = (msgType) => {
    if (!msgType) return false;
    return ["text", "auto_text"].indexOf(msgType) > -1;
}

/**
 * Return the reply message format object from given message
 * @param {*} message 
 */
 export const getReplyMessageFormat = (message) => {
    if (!message) return {};
    return {
        chatType: message.chatType,
        deletedBy: message.deleteStatus,
        deletedStatus: message.deleteStatus,
        fromUserId: isSingleChat(message.chatType) ? message.fromUserId : message.publisherId,
        groupId: isGroupChat(message.chatType) ? message.fromUserId : undefined,
        oldMsgId: "",
        replyMsgContent: message.msgBody,
        replyMsgId: message.msgId
    }
}

/**
 * Could check here active conversation screen chat type by giving the chat type as argument
 * @param {Boolean} chatType 
 */
export const activeConversationChatType = (chatType) => {
    const { activeChatData: { data: { recent } = {} } = {} } = store.getState();
    if (!chatType || !recent) return false;
    return recent.chatType === chatType;
}

/**
 * Get the active conversation group ID
 */
export const getActiveConversationGroupId = () => {
    const { activeChatData: { data: { roster, recent } = {} } = {} } = store.getState();
    let data = roster && Object.keys(roster).length > 0 ? roster : recent;
    return (data?.groupId) || (recent?.fromUserId);
}


/**
 * Return the user or group id based on active conversation
 */
export const getActiveConversationUserOrGroupId = () => {
    const isSingleChatActive = activeConversationChatType(CHAT_TYPE_SINGLE);
    if (isSingleChatActive) {
        return getActiveConversationChatId();
    }
    const isGroupChatActive = activeConversationChatType(CHAT_TYPE_GROUP);
    if (isGroupChatActive) {
        return getActiveConversationGroupId();
    }
    return undefined;
}

export const getNameAndStatus = (jid = '', roster = []) => {
    const userJid = jid.split('@')[0]
    return roster.find(profile => {
        const rosterJid = (profile.username) ? profile.username : profile.userId;
        return rosterJid === userJid
    })
}

export const getBroadCastUser = (participants = [], totalContactList = []) => {
    const rosterContacts = totalContactList.filter(singleContact => {
        const rosterJid = singleContact.jid || singleContact.username;
        return participants.indexOf(rosterJid) !== -1
    })

    return participants.map(groupMember => ({
        ...rosterContacts.find((singleContact) => {
            const rosterJid = singleContact.jid || singleContact.username;
            if (rosterJid === groupMember) {
                return singleContact
            }
        }),
        jid: groupMember
    }));

}


export const formatUserIdToJid = (userId, chatType = CHAT_TYPE_SINGLE) => {
    const jidResponse = chatType === CHAT_TYPE_SINGLE ? SDK.getJid(userId):SDK.getGroupJid(userId)
    if(jidResponse.statusCode === 200){
        return jidResponse.userJid || jidResponse.groupJid
    } 
}

export const getDataFromSDK = async (userId) => {
    let data = { userId: userId, userJid: formatUserIdToJid(userId) };
    if (!requestUserids.includes(userId)) {
        requestUserids.push(userId);
        const profileDetailsResponse = await SDK.getUserProfile(formatUserIdToJid(userId));
        let index = requestUserids.indexOf(userId);
        if (index !== -1) {
            requestUserids.splice(index, 1);
        }
        if (profileDetailsResponse.statusCode === 200) {
            let userProfileDetails = {...profileDetailsResponse.data};
            userProfileDetails.name = userProfileDetails.nickName;
            data = {
                ...data,
                ...userProfileDetails,
            };
            addVcardDataToRoster(data);
        } else {
            data = {
                ...data,
                isDeletedUser: true,
                email: "",
                image: "",
                isAdminBlocked: false,
                isFriend: false,
                mobileNumber: "",
                name: "Deleted User",
                nickName: "Deleted User",
                displayName: "Deleted User",
                status: ""
            }
            addVcardDataToRoster(data);
        }
        return data;
    }
    return data;
}

export const handleParticipantList = (participants = [], totalContactList = []) => {
    return participants.map(groupMember => ({
        ...(getDataFromRoster(groupMember.userId) || {}),
        ...groupMember
    }));

}

export const displayNameFromRencentChat = (roster = {}) => {
    const { displayName, name, nickName, jid, groupName } = roster || {};
    return displayName || groupName || name || nickName || jid;
}

/**
 * Get the active conversation user ID
 */
export const getActiveConversationChatJid = () => {
    const { activeChatData: { data: [{ chatJid } = {}] } = {} } = store.getState();
    return chatJid;
}

/**
 * Get the active conversation user Jid
 */
export const getActiveConversationUserJid = () => {
    const { activeChatData: { data: [{ chatId, chatType }={}] = [] } = {} } = store.getState();
    return formatUserIdToJid(chatId, chatType);
}

/**
 * Get the active conversation group Jid
 */
export const getActiveConversationGroupJid = () => {
    const groupId = getActiveConversationGroupId();
    return formatGroupIdToJid(groupId);
}

/**
 * Return message details from active conversation array for given message Id
 */
export const getActiveConversationMessageByMsgId = (msgId, chatType) => {
    let message = undefined;
    let chatHistory = [];
    if (isSingleChat(chatType) || activeConversationChatType(CHAT_TYPE_SINGLE)) {
        chatHistory = store.getState().singleChatMsgHistoryData?.data;
    }

    if (isGroupChat(chatType) || activeConversationChatType(CHAT_TYPE_GROUP)) {
        chatHistory = store.getState().groupChatMessage?.data;
    }
    chatHistory = (chatHistory && Array.isArray(chatHistory) && chatHistory) || [];
    // Loop through from the recent messages that's why we loop through in backward
    // couldn't use reverse method, it's affected across the app
    for (let i = (chatHistory.length - 1); i >= 0; i--) {
        if (chatHistory[i] && chatHistory[i].msgId === msgId) {
            message = chatHistory[i];
            break;
        }
    }
    return message;
}

/**
 * Get the active conversation user ID
 */
export const getActiveConversationChatId = () => {
    const { activeChatData: { data:[ { chatId } = {}] }= {}  } = store.getState();
    return chatId;
}

export const getChatMessageHistoryById = (id) => {
    const { chatConversationHistory } = store.getState() || {};
    const { data = {} } = chatConversationHistory
    if (data[id]?.messages) return Object.values(data[id]?.messages);
    return [];
};

/**
 * Function to format the phone number in international format
 * @param {data} string
 */
export const getFormatPhoneNumber = (name) => {
    if (name && name !== "undefined" && name.length <= 15) {
        try {
            const number = phoneUtil.parseAndKeepRawInput("+" + name, "");
            return phoneUtil.format(number, PNF.INTERNATIONAL);
        } catch (e) {
            return name;
        }
    }
    return name;
};

export const displayNameFromRoster = (roster, msgFrom) => {
    return getContactNameFromRoster(roster)
}


export const getDisplayNameFromGroup = (messageFrom = '', groupMemberDetails = []) => {

    const userId = messageFrom.split('@')[0]
    const rosterObject = getDataFromRoster(userId);
    if (!rosterObject) {
        const userDetails = getUserDetails(userId);
        if (userDetails.nickName) {
            return {
                nameToDisplay: userDetails.nickName,
                userColor: 'black'
            };
        }
        return {
            nameToDisplay: getFormatPhoneNumber(userId),
            userColor: 'black'
        };
    }
    const { displayName, name, nickName, jid, userColor } = rosterObject || {}
    let nameToDisplay = displayName || name || nickName || jid || getFormatPhoneNumber(messageFrom.split('@')[0]);

    return {
        nameToDisplay,
        userColor
    }
}

export const getDownloadFileName = (file_url, msgType) => {
    const time = `${moment().format("YYYY-MM-DD")} at ${moment().format("hh.mm.ss A")}`;
    const extension = getExtension(file_url);
    const fileType = msgType === "audio" ? "ptt": msgType;
    return `${BRAND_NAME} ${capitalizeFirstLetter(fileType)} ${time}${extension}`;
};

export const downloadMediaFile = async (file_url, msgType, file_name, fileKey, event) => {
    if (blockOfflineAction()) return;

    if (file_url) {
        const fileName = msgType === "file" ? file_name : getDownloadFileName(file_url, msgType);
        let fileUrl = file_url;
        // For Downloading Live File with Original Name
        if (file_url.search("blob:") === -1) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            const mediaResponse = await SDK.getMediaURL(file_url, fileKey);
            if (mediaResponse.statusCode === 200) {
                fileUrl = mediaResponse.data.blobUrl;
            } else {
                console.log("error in downloading media file");
                return;
            }
        }
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.href = fileUrl;
        anchor.setAttribute("download", fileName);
        document.body.appendChild(anchor);
        anchor.click();
        window.URL.revokeObjectURL(anchor.href);
        document.body.removeChild(anchor);
    }
}

export const setTempMute = (name, stateData) => {
    const tempMuteUser = getFromLocalStorageAndDecrypt('tempMuteUser')
    let parserLocalStorage = tempMuteUser ? JSON.parse(tempMuteUser) : {}
    const constructObject = {
        ...parserLocalStorage,
        [name]: stateData
    }
    encryptAndStoreInLocalStorage('tempMuteUser', JSON.stringify(constructObject));
}

export const removeTempMute = (name) => {
    const tempMuteUser = getFromLocalStorageAndDecrypt('tempMuteUser');
    if(tempMuteUser){
        let parserLocalStorage = JSON.parse(tempMuteUser);
        delete parserLocalStorage[name];
        encryptAndStoreInLocalStorage('tempMuteUser', JSON.stringify(parserLocalStorage));
    }
}

export const getActiveChatMessages = () => {
    const chatId = getActiveConversationChatId();
    const { chatConversationHistory: { data } = {} } = store.getState();
    if (data[chatId]?.messages) return Object.values(data[chatId]?.messages);
    return [];
};

const getlabel = (current_datetime) => {
    const today = moment();
    const dateObject = new Date(current_datetime.replace(/ /g, "T"))
    const diffenceDay = today.diff(current_datetime, 'days')
    if (diffenceDay === 0) {
        return 'Today'
    } else if (diffenceDay === 1) {
        return 'Yesterday'
    } else if (diffenceDay > 1 && diffenceDay <= 6) {
        return DateTime.fromJSDate(dateObject).toFormat('cccc')
    } else if (dateObject.getFullYear() === new Date().getFullYear()) {
        return `${dateObject.getDate()} ${months[dateObject.getMonth()]}`
    }
    return `${dateObject.getDate()} ${months[dateObject.getMonth()]} ${dateObject.getFullYear()}`
}

export const convertDateFormat = (dateString) => {
    return getlabel(dateString);
}

export const groupBy = (messageToGroup, callback) => {
    return messageToGroup.reduce((groups, message) => {
        const date = callback(message)
        groups[date] = [...groups[date] || [], message];
        return groups;
    }, {});
}

export const groupByTime = (message, callback) => {
    const { res } = message
        .reduce((messageGroup, singleImage, currentIndex, messageArray) => {
            const time = callback(singleImage)
            if (!messageGroup.currentTime || (messageGroup.currentTime - time > 60000 || (singleImage.msgtype !== messageGroup.messageType || singleImage.fromUser !== messageGroup.fromUser))) {
                messageGroup.currentArray = [];
                messageGroup.res = [
                    ...messageGroup.res,
                    messageGroup.currentArray
                ]
                messageGroup.fromUser = singleImage.fromUser
                messageGroup.messageType = singleImage.msgtype
                messageGroup.currentTime = time
            }
            const previousObject = messageArray[currentIndex - 1]
            messageGroup.previousMessageUser = previousObject && previousObject.msgType !== GROUP_CHAT_PROFILE_UPDATED_NOTIFY ? getSenderIdFromMsgObj(previousObject) : null
            messageGroup.currentArray.push({
                ...singleImage,
                previousMessageUser: messageGroup.previousMessageUser,
                ...(singleImage?.chatType === "groupchat" && !singleImage.publisherId && { publisherId: singleImage.fromUserId })
            })
            return messageGroup
        }, { res: [] })
    return res;
}

/**
 * Chat conversation message status element
 * @param {*} status 
 * @param {*} publisherId 
 */
export const getMsgStatusEle = (status, publisherId) => {
    if (isLocalUser(publisherId)) {
        const updatedStatus = deliveryStatus[status];
        const { mf_IconUploading } = store.getState()?.dynamicIcon?.data
        return (
            <span className={`status ${updatedStatus}`}>
                {status === MSG_PROCESSING_STATUS_ID && (
                    <i className="uploading">
                        <CustomIcon
                            icon={mf_IconUploading ? mf_IconUploading : <IconUploadingHoc viewBox="0 0 16 15"/>}
                        />
                    </i>
                )}
            </span>
        );
    }
    return null;
}

export const getMessageFromHistoryById = (chatId, msgId) => {
    const { chatConversationHistory: { data } = {} } = store.getState();
    if (data[chatId]?.messages && Object.keys(data[chatId]?.messages).length > 0) {
        return data[chatId]?.messages[msgId] || {};
    }
    return {};
};


export const offlineReplyHandle = (newObj = {}, replyTo = "") => {
    const dataObj = {
        oldMsgId: "",
        deletedBy: "0",
        replyMsgId: replyTo,
        chatType: _get(newObj, "chatType", ""),
        groupId: _get(newObj, "fromUserId", ""),
        replyMsgContent: _get(newObj, "msgBody", {}),
        deleteStatus: _get(newObj, "deleteStatus", ""),
        fromUserId: _get(newObj, "chatType", "") === "groupchat" ? _get(newObj, "publisherId", "") : _get(newObj, "fromUserId", ""),
    };
    store.dispatch(addReplyMessageData(dataObj));
};


export const uploadFileToSDK = async ( files, jid, msgId, medias) => {
    const msgObj = store.getState()?.pendingMedia.data.filter(ele=>msgId === ele.msgId)
    const { msgBody: {media:{ file = {} }} }=msgObj[0]
    const media = msgObj[0]?.msgBody?.media
    const { caption = "", fileDetails: { replyTo, duration = 0, imageUrl = "", audioType = "" } = {} } = file;
    const msgType = getMessageType(file.type, file);
    let fileOptions = {
        msgId: msgId,
        caption: caption,
        duration: duration,
        webWidth: media.webWidth || 0,
        webHeight: media.webHeight || 0,
        androidWidth: media.androidWidth || 0,
        androidHeight: media.androidHeight || 0,
        originalWidth: media.originalWidth || 0,
        originalHeight: media.originalHeight || 0,
        ...(msgType === "video" && { thumbImage: imageUrl }),
        ...(msgType === "audio" && { audioType })
    };

    let response = {};
    if (msgType === "file") {
        response = await SDK.sendDocumentMessage(jid, file, fileOptions, replyTo);
    } else if (msgType === "image") {
        response = await SDK.sendImageMessage(jid, file, fileOptions, replyTo);
    } else if (msgType === "video") {
        response = await SDK.sendVideoMessage(jid, file, fileOptions, replyTo);
    } else if (msgType === "audio") {
        response = await SDK.sendAudioMessage(jid, file, fileOptions, replyTo);
    }
    let updateObj = {
        msgId,
        statusCode: response.statusCode,
        fromUserId: getUserIdFromJid(jid)
    };
    if (response.statusCode === 200) {
        /**
        if (msgType === "image" || msgType === "audio") {
            // const fileBlob = await fileToBlob(file);
            // indexedDb.setImage(response.fileToken, fileBlob, getDbInstanceName(msgType));
        }
        */
        updateObj.fileToken = response.data.msgBody.media.fileToken;
        updateObj.thumbImage =  response.data.msgBody.media.thumbImage;
        updateObj.fileKey = response.data.msgBody.media.file_key;
        store.dispatch(removePendindMedia(msgId));
    } else if (response.statusCode === 500) {
        updateObj.uploadStatus = 3;
    }
    store.dispatch(updateUploadStatus(updateObj));
};

export const updateMediaUploadStatusHistory = (data, stateData) => {
    // Here Get the Current Active Chat History and Active Message
    const currentChatData = stateData[data.fromUserId];
    if (currentChatData?.messages && Object.keys(currentChatData?.messages).length > 0) {
        const currentMessage = currentChatData.messages[data.msgId];
        if (currentMessage) {
            currentMessage.msgBody.media.is_uploading = data.uploadStatus;
            return {
                ...stateData,
                [data.fromUserId]: {
                    ...currentChatData,
                    [data.msgId]: currentMessage
                }
            };
        }
    }
    return {
        ...stateData
    };
};

export const getChatHistoryMessagesData = () => {
    const { chatConversationHistory: { data } = {} } = store.getState();
    return data;
};

export const handleTempArchivedChats = (chatJid, chatType) => {
    const archivedChats = getArchivedChats(),
        isPermanentArchvie = getArchiveSetting(),
        chatId = getUserIdFromJid(chatJid);
    
    if (chatId && archivedChats.includes(chatId) && !isPermanentArchvie) {
        handleUnarchiveChat(chatId, chatType);
    }
};

export const getBlobUrlFromToken = (fileToken, dbInstance, fileKey) => {
    return indexedDb
      .getImageByKey(fileToken, dbInstance, fileKey)
      .then((blob) =>  window.URL.createObjectURL(blob))
      .catch(() =>  "");
}

export const updateMessageTranslate = (data, stateData) => {
    const currentChatData = stateData[data.fromUserId];
    if (currentChatData?.messages && Object.keys(currentChatData?.messages).length > 0) {
        const currentMessage = currentChatData.messages[data.msgId];
        if (currentMessage) {
            currentMessage.msgBody.translatedMessage = data.translatedMessage;
            return {
                ...stateData,
                [data.fromUserId]: {
                    ...currentChatData,
                    [data.msgId]: currentMessage
                }
            };
        }
    }
    return {
        ...stateData
    };
};

export const handleUserSettings = async () => {
    const userSettings = await SDK.getUserSettings();
    const webSettings = getLocalWebsettings() || {};
    store.dispatch(webLocalStorageSetting({ 
        "isEnableArchived" : userSettings?.data?.archive === 0 ? false : true,
        "translate": webSettings.translate || false
    }));
    setLocalWebsettings("archive", userSettings?.data?.archive === 0 ? false : true);
}

export function formatBytes(a, b = 2) { 
    if (0 === a) 
    {return "0 Bytes"}
    const c = 0 > b ? 0 : b, d = Math.floor(Math.log(a) / Math.log(1024));
    return parseFloat((a / Math.pow(1024, d)).toFixed(c)) + " " + ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
}

export const updateDeletedMessageInHistory = (actionType, data, stateData) => {
    // Here Get the Current Active Chat History and Active Message
    const currentChatData = stateData[data.fromUserId];
    if (currentChatData) {
        if (actionType === "DELETE_MESSAGE_FOR_ME") {
            data.msgIds.forEach((msgId) => delete currentChatData.messages[msgId]);
        } else if (actionType === "DELETE_MESSAGE_FOR_EVERYONE") {
            const messageIds = data.msgId.split(",");
            for (const element of messageIds) {
                const msgId = element;
                if (currentChatData.messages[msgId]){
                    currentChatData.messages[msgId].deleteStatus = 2;
                }
            }
            /**
             for (let i = 0; i < messageIds.length; i++) {
                const msgId = messageIds[i];
                if (currentChatData.messages[msgId]){
                    currentChatData.messages[msgId].deleteStatus = 2;
                }
            }
             */
        }

        return {
            ...stateData,
            [data.fromUserId]: {
                ...currentChatData
            }
        };
    }
    return {
        ...stateData
    };
};

export const getChatHistoryData = (data, stateData) => {
    // To Avoid Unnecessary Looping, We are Using Key Value Pair for Chat and Messages
    // Eg: userId: {} or groupId: {} or msgId: {}
    const chatId = getUserIdFromJid(data.userJid || data.groupJid);
    const typedMessage = stateData[chatId]?.typedMessage;
    const state = Object.keys(stateData).length > 0 ? stateData[chatId]?.messages || {} : {};
    const sortedData = concatMessageArray(data.data, Object.values(state), "msgId", "timestamp");
    const lastMessage = sortedData[sortedData.length - 1];
    let newSortedData;
    const localUserJid = getFromLocalStorageAndDecrypt('loggedInUserJidWithResource');
    const userId = localUserJid ? getUserIdFromJid(localUserJid) : "";
    if (userId === lastMessage?.publisherId) {
        newSortedData = sortedData.map((msg => {
            msg.msgStatus = getMsgStatusInOrder(msg.msgStatus, lastMessage?.msgStatus);
            return msg;
        }));
    } else  newSortedData = sortedData;

    let isScrollNeeded = true;
    if (data.fetchLimit) {
        isScrollNeeded = data.data.length === data.fetchLimit; // To Check If this is the Last Message in the Chat, So no Scroll Fetch is Needed
    }
    const finalData = { isScrollNeeded, messages: arrayToObject(newSortedData, "msgId"),typedMessage: typedMessage };
    
    let datata= {
        ...stateData,
        [chatId]: finalData
    };
    return datata
};


export const concatMessageArray = (activeData, stateData, uniqueId, sortId) => {
    const updateMessage = [
        ...stateData,
        ...activeData,
    ]
    // a[sortId] > b[sortId] ? 1 : a[sortId] < b[sortId] ? -1 : 0
    return getUniqueListBy(updateMessage, uniqueId).sort((a, b) => {
        if(a[sortId] > b[sortId]) return 1;
        else if(a[sortId] < b[sortId]) return -1;
        else return 0;
    });
}

export const getMsgStatusInOrder = (currentStatus, newStatus) => {
    const currentStatusIndex = msgStatusOrder.indexOf(currentStatus);
    const newStatusIndex = msgStatusOrder.indexOf(newStatus);
    if (newStatusIndex > currentStatusIndex) {
        return newStatus;
    }
    return currentStatus;
}

export const arrayToObject = (arr, key) => {
    return arr.reduce((obj, item) => {
        obj[item[key]] = item;
        return obj;
    }, {});
};

export const getUniqueListBy = (arr, key) => {
    return [...new Map(arr.map(item => [item[key], item])).values()]
}

export const getUpdatedHistoryData = (data, stateData) => {
    // Here Get the Current Active Chat History and Active Message
    const currentChatData = stateData[data.fromUserId];
    const msgIds = currentChatData?.messages ? Object.keys(currentChatData?.messages) : {};
    if (msgIds.length > 0) {
        const currentMessage = currentChatData.messages[data.msgId];
        if (currentMessage) {
            const msgStatus = getMsgStatusInOrder(currentMessage.msgStatus, data.msgStatus);
            currentMessage.msgStatus = msgStatus;
            currentMessage.msgType = data.msgType;
            if (currentMessage?.msgBody?.media && data.msgType === "acknowledge") {
                currentMessage.msgBody.media.is_uploading = 2
            }
            
            // Updating Old Msg Statuses to Current Status
            const currentMessageIndex = msgIds.indexOf(data.msgId);
            for (let i = 0; i < msgIds.length && i <= currentMessageIndex; i++) {
                const  message = currentChatData?.messages[msgIds[i]];
                currentChatData.messages[msgIds[i]] = {
                    ...message, 
                    ...(message.msgStatus !== 3 && {
                        msgStatus : getMsgStatusInOrder(message.msgStatus, msgStatus)
                    })
                };
            }

            return {
                ...stateData,
                [data.fromUserId]: {
                    ...currentChatData,
                    [data.msgId]: currentMessage
                }
            };
        }
    }
    return {
        ...stateData
    };
};

export const reconnectUpdateHistory = (data, stateData) => {
    // Here Get the Current Active Chat History and Active Message
    const currentChatData = stateData[data.fromUserId];
    const msgIds = currentChatData?.messages ? Object.keys(currentChatData?.messages) : {};
    if (msgIds.length > 0) {
            return {
                ...stateData,
                [data.fromUserId]: {
                    ...currentChatData,
                        messages:{
                            ...currentChatData.messages,[data.msgId]: data
                        }
                    }
                    
                }
        }
    };
    
export const getRecentChatData = () => {
    const { recentChatData: { data = [] } = {} } = store.getState();
    return data;
};

export const getLastMsgFromHistoryById = (chatId) => {
    const chatMessages = getChatMessageHistoryById(chatId);
    return chatMessages.length > 0 ? chatMessages[chatMessages.length - 1] : "";
};

export const messageInfoAction = (data, forceUpdate) => {
    const { statusUpdate = true, messageId } = data;
      const getcurrentState = store.getState();
      if (statusUpdate) {
        const messageObject = getcurrentState?.recentChatData?.data.find((ele) => ele.msgId === messageId);
        if (messageObject) {
          store.dispatch(addRecentChatStatus({ id: uuidv4(), data:data }))
        }
      }
    store.dispatch(addMessageInfoData({id: uuidv4(), data:data}))
  };
/**
//   export const updateVCardData = (data) => {    
//     // store.dispatch(vcardUpdate(data))
//     store.dispatch(rosterUpdate(data))
//   };
*/


export const getUpdatedHistoryDataUpload = (data, stateData) => {
    // Here Get the Current Active Chat History and Active Message
    const currentChatData = stateData[data.fromUserId];
    if (currentChatData?.messages && Object.keys(currentChatData?.messages).length > 0) {
        const currentMessage = currentChatData.messages[data.msgId];

        if (currentMessage) {
            currentMessage.msgBody.media.is_uploading = data.uploadStatus;
            if (data.statusCode === 200) {
                currentMessage.msgBody.media.file_url = data.fileToken || "";
                currentMessage.msgBody.media.thumb_image = data.thumbImage || "";
                currentMessage.msgBody.media.file_key = data.fileKey || "";
            }

            let msgIds = Object.keys(currentChatData?.messages);
            let nextIndex = msgIds.indexOf(data.msgId) + 1;
            let nextItem = msgIds[nextIndex];

            if (nextItem) {
                let nextMessage = currentChatData.messages[nextItem];
                if (nextMessage?.msgBody?.media?.is_uploading === 0) {
                    nextMessage.msgBody.media.is_uploading = 1;

                    return {
                        ...stateData,
                        [data.fromUserId]: {
                            ...currentChatData,
                            [data.msgId]: currentMessage,
                            [nextItem]: nextMessage
                        }
                    };
                }
            }
            return {
                ...stateData,
                [data.fromUserId]: {
                    ...currentChatData,
                    [data.msgId]: currentMessage
                }
            };
        }
    }
    return {
        ...stateData
    };
};

export const reconnectChatImagePending = (data, stateData) => {
    const chatId = getUserIdFromJid(data.userJid || data.groupJid);
    const typedMessage = stateData[chatId]?.typedMessage;
    const state = Object.keys(stateData).length > 0 ? stateData[chatId]?.messages || {} : {};
    const sortedData = concatMessageArray(data.data, Object.values(state), "msgId", "timestamp");
    const lastMessage = sortedData[sortedData.length - 1];
    let newSortedData;
    const localUserJid = getFromLocalStorageAndDecrypt('loggedInUserJidWithResource');
    const userId = localUserJid ? getUserIdFromJid(localUserJid) : "";
    if (userId === lastMessage?.publisherId) {
        newSortedData = sortedData.map((msg => {
            msg.msgStatus = getMsgStatusInOrder(msg.msgStatus, lastMessage?.msgStatus);
            return msg;
        }));
    } else  newSortedData = sortedData;
    let isScrollNeeded = true;
    if (data.fetchLimit) {
        isScrollNeeded = data.data.length === data.fetchLimit; // To Check If this is the Last Message in the Chat, So no Scroll Fetch is Needed
    }
    const newCreatedEdited = checkNewMsg(newSortedData)
    const finalData = { isScrollNeeded, messages: arrayToObject(newCreatedEdited, "msgId"),typedMessage: typedMessage };
    return {
        ...stateData,
        [chatId]: finalData
    };
}

const checkNewMsg = (newData) => {
    let sentMsg = []
    let uploadingMSg = []
    for( const ele of newData ){
        ele.msgStatus === 3 ? uploadingMSg.push(ele) : sentMsg.push(ele)
    }
    uploadingMSg = uploadingMSg.map(ele=>{
        return {
            ...ele,msgBody:{
                ...ele.msgBody,
                    media:{
                        ...ele.msgBody.media,
                        is_uploading:20
                    }
            }
        }
    } )
    return [ ...sentMsg,...uploadingMSg ]
}

export const copyToClipboard = (copyMessage) => {
    navigator.clipboard.writeText(copyMessage);
}

export const getMessagesForReport = (chatId, selectedMsgIdType) => {
    const chatMessages = getChatMessageHistoryById(chatId);
    let msgDataArray = [];
    const sortedData = chatMessages.filter((item)=>(Object.keys(item.msgBody).length !==0)).sort((a, b) => (b.timestamp < a.timestamp ? -1 : 1));
    if (sortedData.length) {
        let selectedMsgId = selectedMsgIdType !== REPORT_FROM_CONTACT_INFO ? selectedMsgIdType : sortedData[0]?.msgId
        let count = 0;
        const filteredData = sortedData.filter(msg => {
            if (msg.msgId === selectedMsgId || (count > 0 && count < reportMembers) ) {
                count++;
                return msg;
            }
        });
        filteredData.map((item,key)=>{
            let msgObject = {}
            msgObject["msgId"] = item?.msgId || ""
            msgObject["message"] = item?.msgBody?.message || item?.msgBody?.media?.caption || ""
            msgObject["msgType"] = item?.msgBody?.message_type || ""
            msgObject["filename"] = item?.msgBody?.media?.fileName || ""
            msgObject["timestamp"] = item?.timestamp
            msgObject["publisherId"] = item?.publisherId || item?.fromUserId
            msgDataArray.push(msgObject)
        })
    }else if(sortedData.length === 0){
        return msgDataArray
    }
    return msgDataArray
};


